import { h } from "@stencil/core";
import { uniWatermark } from "../../../license";
export class UniTestProComponent {
    connectedCallback() {
        uniWatermark('pro');
    }
    render() {
        return h("h1", null, h("slot", null));
    }
    static get is() { return "uni-test-pro"; }
}
//# sourceMappingURL=test-pro.component.js.map
